// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'POST',
    endpoint: '/api/bop-go/import-ordini/drive/scansiona',
    requestBody: '{"societaId":1}',
    response: '{"success":true,"data":{"fileTrovati":3,"lotti":[{"insegna":"Bricocenter","caricamentoId":12,"esito":"inviati a GO 20 ordini su 20"}],"fileNonRiconosciuti":[],"fileDuplicati":[],"errori":[],"durataMs":45000}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini?societaId=&insegnaId=&stato=',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"societaId":1,"etichetta":"Bricocenter 20/08","note":null,"stato":"CARICATO","utenteName":"...","totaleFile":3,"ordiniCreati":0,"righeCreate":0,"righeNonRisolte":0,"createdAt":"...","insegna":{"id":1,"codice":"BC","nome":"Bricocenter"},"_count":{"file":3},"totaleDaFile":3557.06,"totaleInGo":3557.06,"ordiniInviati":20}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/insegne?societaId=1',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"codice":"BC","nome":"Bricocenter"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/import-ordini',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"fileCaricati":3,"scartati":[{"nomeFile":"a.xml","motivo":"già caricato..."}],"avvisi":[]}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
